import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-multi-select-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule],
  template: `
    <div class="field-wrapper field-wrapper--select" [class]="field.cssClass" [class.has-error]="isInvalid">

      <label [for]="field.id">{{ field.label }}<a *ngIf="hasLabelLink" [href]="field.linkUrl" [target]="field.linkTarget ?? '_blank'" [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null">{{ field.linkText }}</a></label>

      <!-- Modo lista: checkboxes visibles sin desplegar -->
      <div *ngIf="isListMode; else dropdownMode"
           class="af-multiselect-list"
           [id]="field.id"
           role="group"
           [attr.aria-label]="field.label">
        <label
          *ngFor="let opt of field.options"
          class="af-multiselect-list__item"
          [class.is-disabled]="opt.disabled || field.disabled">
          <mat-checkbox
            [checked]="isChecked(opt.value)"
            (change)="toggleOption(opt.value, $event.checked)"
            [disabled]="(opt.disabled ?? false) || (field.disabled ?? false)"
            color="primary">
            {{ opt.label }}
          </mat-checkbox>
        </label>
      </div>

      <!-- Modo desplegable (por defecto) -->
      <ng-template #dropdownMode>
        <mat-form-field class="af-mat-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            [id]="field.id"
            [formControl]="control"
            [multiple]="true"
            [placeholder]="field.placeholder ?? 'Seleccione...'">
            <mat-option
              *ngFor="let opt of field.options"
              [value]="opt.value"
              [disabled]="opt.disabled ?? false">
              {{ opt.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>

      <small *ngIf="field.hint && !isInvalid && !isPending"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>

      <span *ngIf="isPending" class="field-pending">
        Verificando...
      </span>

      <small *ngIf="isInvalid" class="error">
        {{ errorMessage }}
      </small>

    </div>
  `,
  styles: [`
    .af-multiselect-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 8px 0;
    }
    .af-multiselect-list__item {
      display: flex;
      align-items: center;
    }
    .af-multiselect-list__item.is-disabled {
      opacity: 0.5;
    }
  `]
})
export class MultiSelectFieldComponent extends BaseFieldComponent {

  get isListMode(): boolean {
    const props = this.field?.customProps as Record<string, unknown> | undefined;
    return props?.['displayMode'] === 'list';
  }

  isChecked(value: unknown): boolean {
    const current = this.control.value;
    if (Array.isArray(current)) {
      return current.includes(value);
    }
    return false;
  }

  toggleOption(value: unknown, checked: boolean): void {
    const current: unknown[] = Array.isArray(this.control.value) ? [...this.control.value] : [];
    if (checked) {
      if (!current.includes(value)) current.push(value);
    } else {
      const idx = current.indexOf(value);
      if (idx !== -1) current.splice(idx, 1);
    }
    this.control.setValue(current);
    this.control.markAsTouched();
  }
}
